export default function() {
  return new Worker(__webpack_public_path__ + "search.worker-11eaaee628b4849a1463.worker.js");
}
